import script from "./payment_end.vue?vue&type=script&setup=true&lang=ts"
export * from "./payment_end.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__